import { render, staticRenderFns } from "./list-order-consult.vue?vue&type=template&id=1f6dd2dd&scoped=true"
import script from "./list-order-consult.vue?vue&type=script&lang=js"
export * from "./list-order-consult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6dd2dd",
  null
  
)

export default component.exports